import { createContext, useContext, type ReactNode } from 'react';

/**
 * ORIGEM DOS CARTOES - de qual conversa um cartao foi desenhado.
 *
 * Os cartoes avisam a pagina que uma confirmacao aconteceu (`rimati-confirmed`)
 * para que a conversa retome o pedido. Sem origem, qualquer cartao da app
 * (configuracoes, ativacao de assistente) acordaria a conversa do painel. Quem
 * desenha uma conversa envolve os cartoes neste provedor; os cartoes fora de
 * uma conversa recebem `null` e ninguem os escuta.
 */
const ChatOriginContext = createContext<string | null>(null);

export function ChatOriginProvider({
  sessionId,
  children,
}: {
  sessionId: string | null;
  children: ReactNode;
}): ReactNode {
  return <ChatOriginContext.Provider value={sessionId}>{children}</ChatOriginContext.Provider>;
}

export const useChatOrigin = (): string | null => useContext(ChatOriginContext);

export const CONFIRMED_EVENT = 'rimati-confirmed';

export interface ConfirmedDetail {
  label: string;
  /** A conversa que desenhou o cartao; `null` fora de uma conversa. */
  sessionId?: string | null;
  operationId?: string;
  companyId?: string;
  userId?: string;
}

export function emitConfirmed(detail: ConfirmedDetail): void {
  window.dispatchEvent(new CustomEvent<ConfirmedDetail>(CONFIRMED_EVENT, { detail }));
}
